document.addEventListener('DOMContentLoaded', function () {
  var min = 3;
  var max = 20;
  var viewerCount = Math.floor(Math.random() * (max - min + 1)) + min;
  var viewerElement = document.getElementById('viewer-count');
  if (viewerElement) {
      viewerElement.textContent = viewerCount;
  }
});